import { pageNames } from "utils/Types";
import { noPlansMessageCommon } from "./NoPlansMessageCommon";

export const noPlansMessageCorpUser = {
  ...noPlansMessageCommon,
  [pageNames.suggested]: {
    label: "Suggested",
    title: "No plans are currently available - that's okay.",
    content: "You can retake the Wizard or search the Library.",
    showButton: false
  },
  [pageNames.noSuggestedFilter]: {
    label: "All Plans",
    title: "No additional suggested plans are available - that's okay.",
    content: "You can retake the Wizard or search the Library.",
    showButton: false
  },
  [pageNames.myPlans]: {
    label: "myPlans",
    title: "There are no plans to show for the selected Inncode(s).",

    showButton: true,
    buttonLabel: "Explore plans"
  },
  [pageNames.noActivePlans]: {
    label: "onBoardingSuggestions",
    title: "Your onboarding is 100% complete",
    content: "Based on your current preferences we found some suggestions for you.",
    showButton: true,
    buttonLabel: "See Suggested plans"
  },
  [pageNames.noAssignAction]: {
    label: "onBoardingAssign",
    content: "Ready to assign your first action?",
    showButton: true,
    buttonLabel: "Assign Action"
  },
  [pageNames.noReports]: {
    label: "CompletedPlanReports",
    title: `You have no Completed Plans`,
    showButton: false
  },
  [pageNames.searchResultAction]: {
    label: "Individual Actions",
    title: "There are no actions for this Functional Areas.",
    content: "We are always adding the most relevant content for you so continue to check back.",
    showButton: false
  },
  [pageNames.globalSearchResult]: {
    label: "Global Search",
    title: "There are currently no actions for this search.",
    content: "We are always adding new content, continue to check back.",
    showButton: false
  },
  [pageNames.aboveProperty]: {
    label: "Above Property",
    title: "No properties currently bookmarked",
    content: "",
    showButton: true
  },
  [pageNames.abovePropertyPlans]: {
    label: "Above Property",
    title: "No plans currently bookmarked",
    content: "",
    showButton: false
  },
  [pageNames.reviewPlanAssignment]: {
    label: "Review Plan Assignments",
    title: "No orphaned plans found.",
    content: "All your plans currently have an assigned owner and all actions assigned.",
    showButton: false
  }
};
